import { useRef, useCallback } from 'react';

/**
 * Hook for managing panel references and reset operations
 */
export function usePanelRefs() {
  const patternPanelRef = useRef(null);
  const metadataPanelRef = useRef(null);
  const findReplacePanelRef = useRef(null);
  const fmoPanelRef = useRef(null);

  // Reset pattern panel
  const resetPatternPanel = useCallback(() => {
    if (patternPanelRef.current?.reset) {
      patternPanelRef.current.reset();
    }
  }, []);

  // Reset metadata panel
  const resetMetadataPanel = useCallback(() => {
    if (metadataPanelRef.current?.reset) {
      metadataPanelRef.current.reset();
    }
  }, []);

  // Reset find replace panel
  const resetFindReplacePanel = useCallback(() => {
    if (findReplacePanelRef.current?.reset) {
      findReplacePanelRef.current.reset();
    }
  }, []);

  // Reset FMO panel
  const resetFMOPanel = useCallback(() => {
    if (fmoPanelRef.current?.reset) {
      fmoPanelRef.current.reset();
    }
  }, []);

  // Reset all panels
  const resetAllPanels = useCallback(() => {
    resetPatternPanel();
    resetMetadataPanel();
    resetFindReplacePanel();
    resetFMOPanel();
  }, [resetPatternPanel, resetMetadataPanel, resetFindReplacePanel, resetFMOPanel]);

  // Reset specific panels
  const resetPanels = useCallback((panels = []) => {
    if (panels.includes('pattern')) resetPatternPanel();
    if (panels.includes('metadata')) resetMetadataPanel();
    if (panels.includes('findreplace')) resetFindReplacePanel();
    if (panels.includes('fmo')) resetFMOPanel();
  }, [resetPatternPanel, resetMetadataPanel, resetFindReplacePanel, resetFMOPanel]);

  return {
    // Refs
    patternPanelRef,
    metadataPanelRef,
    findReplacePanelRef,
    fmoPanelRef,

    // Methods
    resetPatternPanel,
    resetMetadataPanel,
    resetFindReplacePanel,
    resetFMOPanel,
    resetAllPanels,
    resetPanels
  };
}